
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

const DeleteConfirmDialog = (props) => {

  const handleClick_delete = () => {
    props.handleDelete(null);
    handleClick_cancel();
  }

  const handleClick_cancel = () => {
    props.tearDown();
  }

  const render = () => {
    return (
      <Dialog
        open={props.show}
        onClose={handleClick_cancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to delete this item. This action can not be reversed. Are you sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClick_cancel} color="primary">
            Opps, no!
          </Button>
          <Button onClick={handleClick_delete} color="primary" style={{color: "red"}} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return render();
}

export default DeleteConfirmDialog;